import { render, staticRenderFns } from "./RbCheckbox.vue?vue&type=template&id=c6126bc6"
import script from "./RbCheckbox.vue?vue&type=script&lang=js"
export * from "./RbCheckbox.vue?vue&type=script&lang=js"
import style0 from "./RbCheckbox.vue?vue&type=style&index=0&id=c6126bc6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports